/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TransportCostPerKm
 */
export interface TransportCostPerKm {
    /**
     * 
     * @type {number}
     * @memberof TransportCostPerKm
     */
    value: number;
    /**
     * 
     * @type {string}
     * @memberof TransportCostPerKm
     */
    currency: string;
}

export function TransportCostPerKmFromJSON(json: any): TransportCostPerKm {
    return TransportCostPerKmFromJSONTyped(json, false);
}

export function TransportCostPerKmFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransportCostPerKm {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': json['value'],
        'currency': json['currency'],
    };
}

export function TransportCostPerKmToJSON(value?: TransportCostPerKm | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': value.value,
        'currency': value.currency,
    };
}


